import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut, PenLine, LayoutDashboard, ExternalLink } from "lucide-react";
import { logout } from "@/lib/auth";

export default function AdminLayout() {
    const nav = useNavigate();
    const onLogout = () => { logout(); nav("/admin/login"); };

    return (
        <div className="min-h-screen bg-[#FAFAFA] flex flex-col">
            <header className="bg-ink text-white border-b border-white/10" data-testid="admin-navbar">
                <div className="container-7m flex items-center justify-between h-16">
                    <Link to="/admin/blog" className="flex items-center gap-3">
                        <img src="https://customer-assets.emergentagent.com/job_zealous-goodall-9/artifacts/o7ztlruv_7med.png" alt="7MED" className="h-9 w-auto object-contain" />
                        <div>
                            <div className="font-heading font-bold text-base leading-none">Admin</div>
                            <div className="text-[9px] uppercase tracking-[0.3em] text-white/40 font-mono mt-1">Backoffice</div>
                        </div>
                    </Link>
                    <nav className="flex items-center gap-2">
                        <NavLink to="/admin/blog" className={({ isActive }) => `flex items-center gap-2 px-3 py-2 text-xs font-mono uppercase tracking-wider rounded-none ${isActive ? "bg-brand text-white" : "text-white/70 hover:text-white"}`} data-testid="admin-nav-blog">
                            <PenLine className="w-4 h-4" /> Blog
                        </NavLink>
                        <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-3 py-2 text-xs font-mono uppercase tracking-wider text-white/50 hover:text-white">
                            <ExternalLink className="w-3.5 h-3.5" /> Sito
                        </a>
                        <button onClick={onLogout} className="flex items-center gap-2 px-3 py-2 text-xs font-mono uppercase tracking-wider text-white/70 hover:text-brand" data-testid="admin-logout">
                            <LogOut className="w-4 h-4" /> Logout
                        </button>
                    </nav>
                </div>
            </header>
            <main className="flex-1">
                <div className="container-7m py-10"><Outlet /></div>
            </main>
        </div>
    );
}
